import { useEffect, useState } from 'react'
import { ExternalLink } from 'lucide-react'
import { fetchTopTracks } from '../lib/api'
import type { SpotifyTrack } from '../lib/api'

export default function TopTracksTile() {
  const [tracks, setTracks] = useState<SpotifyTrack[]>([])

  useEffect(() => {
    fetchTopTracks().then(setTracks).catch(() => {})
  }, [])

  return (
    <div className="life-card rounded-xl p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-heading font-medium text-amber-100">Top Tracks</h3>
        <span className="text-xs text-amber-200/50 uppercase tracking-wider">Past 4 weeks</span>
      </div>

      <ol className="space-y-3">
        {tracks.map((t, i) => (
          <li key={`${t.name}-${i}`} className="flex items-center gap-3 group">
            <span className="text-xs text-amber-200/40 w-5 text-right flex-shrink-0 tabular-nums">
              {i + 1}
            </span>
            {t.albumArt ? (
              <img
                src={t.albumArt}
                alt={t.album}
                className="w-8 h-8 rounded object-cover flex-shrink-0"
              />
            ) : (
              <div className="w-8 h-8 rounded bg-amber-400/10 flex-shrink-0" />
            )}
            <div className="flex-1 min-w-0">
              <p className="text-amber-50 text-sm font-medium truncate">{t.name}</p>
              <p className="text-amber-200/60 text-xs truncate">{t.artist}</p>
            </div>
            {t.spotifyUrl && (
              <a
                href={t.spotifyUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-amber-300/40 hover:text-amber-300 transition-colors flex-shrink-0 opacity-0 group-hover:opacity-100"
                aria-label={`Open ${t.name} in Spotify`}
              >
                <ExternalLink size={13} />
              </a>
            )}
          </li>
        ))}

        {tracks.length === 0 && (
          <li className="text-amber-200/40 text-sm">No data yet</li>
        )}
      </ol>
    </div>
  )
}
